import { DynamicStandaloneTextField, DynamicStandaloneTextFieldProps } from '@/components/TextField';
import { propClassName } from '@/styles/Navigation';
import { StandaloneComponent } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface NavigationTextFieldProps extends Omit<DynamicStandaloneTextFieldProps, 'caption' | 'label'> {}

export const NavigationTextFieldComponent: StandaloneComponent<NavigationTextFieldProps> = ({ options, ...props }) => {
  const { $input, className, ...baseProps } = options ?? {};
  const { className: inputClassName, ...inputProps } = $input ?? {};

  const inputColorsClassName = propClassName('textField_input_colors', inputProps.colors);
  const inputSizeClassName = propClassName('textField_input_size', inputProps.size);
  const inputVariantClassName = propClassName('textField_input_variant', inputProps.variant);
  const inputComponentClassName = cn(inputColorsClassName, inputSizeClassName, inputVariantClassName, inputClassName);

  const colorsClassName = propClassName('textField_colors', baseProps.colors);
  const sizeClassName = propClassName('textField_size', baseProps.size);
  const variantClassName = propClassName('textField_variant', baseProps.variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <DynamicStandaloneTextField
      options={{
        $caption: { className: 'hidden' },
        $input: {
          className: inputComponentClassName,
          ...inputProps,
        },
        $label: { className: 'hidden' },
        className: componentClassName,
        ...baseProps,
      }}
      {...props}
    />
  );
};
